import { defineMessages } from '@transcend-io/internationalization';

export const notFoundMessages = defineMessages(
  'privacy-center.containers.NotFound.notFound',
  {
    header: {
      defaultMessage: 'Oops! The page you are looking for does not exist!',
    },
    title: {
      defaultMessage: 'Not Found',
    },
  },
);
